import { IconButton } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import * as React from "react";

import {
    Divider,
    EditIcon,
    EnvelopeIcon,
    Label,
    Link,
    RelodeTheme,
    Text,
} from "../../..";
import * as domain from "../../../domain";
import { CandidateInterviewListProps } from "./candidateJobInterviewListProps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
            },
            interview: {
                margin: theme.spacing(2, 0),
            },
            row: {
                display: "flex",
                justifyContent: "space-between",
                marginTop: theme.spacing(2),
            },
            column: {
                flex: "50%",
            },
            alignRight: {
                textAlign: "end",
            },
        }),
    { name: "CandidateJobInterviewListMobile" }
);

export const CandidateJobInterviewListMobile = (
    props: CandidateInterviewListProps
) => {
    const {
        interviewList,
        handleOpenEditInterview,
        handleOpenInterviewDetails,
        handleOpenInterviewNotificationDialog,
    } = props;
    const extendedId = "candidateJobInterviewList";
    const classes = useStyles({});

    return (
        <div id={`${extendedId}Wrapper`} className={classes.root}>
            {interviewList && interviewList.length > 0 && (
                <div id="candidateJobInterviews">
                    {interviewList.map((interview, i) => (
                        <div key={i} className={classes.interview}>
                            <Divider></Divider>
                            <div className={classes.row}>
                                <Label label="date and time">
                                    <Link
                                        onClick={() =>
                                            handleOpenInterviewDetails(
                                                interview
                                            )
                                        }
                                    >
                                        <Text variant="body1">
                                            {interview.startDateTime}{" "}
                                            {
                                                domain.TimeZone.fromId(
                                                    interview.timeZoneId
                                                ).abbreviation
                                            }
                                        </Text>
                                    </Link>
                                </Label>
                                <div className={classes.alignRight}>
                                    {!!handleOpenInterviewNotificationDialog &&
                                    domain.InterviewStatusEnum.fromId(
                                        interview.interviewStatusTypeId
                                    ) ===
                                        domain.InterviewStatusEnum.SCHEDULED ? (
                                        <IconButton
                                            onClick={() =>
                                                handleOpenInterviewNotificationDialog(
                                                    interview
                                                )
                                            }
                                            color="primary"
                                        >
                                            <EnvelopeIcon />
                                        </IconButton>
                                    ) : null}
                                    {!!handleOpenEditInterview ? (
                                        <IconButton
                                            onClick={() =>
                                                handleOpenEditInterview(
                                                    interview
                                                )
                                            }
                                            color="primary"
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    ) : null}
                                </div>
                            </div>
                            <div className={classes.row}>
                                <Label
                                    label="status"
                                    className={classes.column}
                                >
                                    <Text variant="body1">
                                        {
                                            domain.InterviewStatusEnum.fromId(
                                                interview.interviewStatusTypeId
                                            ).label
                                        }
                                    </Text>
                                </Label>
                                <Label label="type" className={classes.column}>
                                    <Text variant="body1">
                                        {
                                            domain.InterviewOptionsEnum.fromId(
                                                interview.interviewTypeId
                                            ).label
                                        }
                                    </Text>
                                </Label>
                                <div></div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
